import React, { Suspense } from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';

/**
 * Loading fallback component
 */
function PageLoader() {
  return (
    <Segment basic style={{ minHeight: '400px' }}>
      <Dimmer active inverted>
        <Loader size="large">Loading...</Loader>
      </Dimmer>
    </Segment>
  );
}

/**
 * Wrap a lazy-loaded component with Suspense
 */
function LazyPage({ Component, ...props }) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component {...props} />
    </Suspense>
  );
}

// Lazy-loaded page components with static imports for proper code splitting
const HomePage = React.lazy(() => import(/* webpackChunkName: "HomePage" */ '../HomePage/HomePage'));
const CreatorLandingPage = React.lazy(() => import(/* webpackChunkName: "CreatorLandingPage" */ '../CreatorLandingPage/CreatorLandingPage'));
const AdminPage = React.lazy(() => import(/* webpackChunkName: "AdminPage" */ '../Utils/AdminPage'));
const Story = React.lazy(() => import(/* webpackChunkName: "Story" */ '../Stories/Story'));
const GameInterface = React.lazy(() => import(/* webpackChunkName: "GameInterface" */ '../GameInterface/GameInterface'));
const CreateListStories = React.lazy(() => import(/* webpackChunkName: "CreateListStories" */ '../Stories/CreateListStories'));
const SelectStories = React.lazy(() => import(/* webpackChunkName: "SelectStories" */ '../Stories/SelectStory'));
const Create = React.lazy(() => import(/* webpackChunkName: "Create" */ '../Create/Create'));
const CreateOptions = React.lazy(() => import(/* webpackChunkName: "CreateOptions" */ '../Create/CreateOptions'));
const StoryGenerator = React.lazy(() => import(/* webpackChunkName: "StoryGenerator" */ '../Create/StoryGenerator'));
const Login = React.lazy(() => import(/* webpackChunkName: "Login" */ '../Login/Login'));
const SignUp = React.lazy(() => import(/* webpackChunkName: "SignUp" */ '../Login/SignUp'));
const ForgotPassword = React.lazy(() => import(/* webpackChunkName: "ForgotPassword" */ '../Login/ForgotPassword'));
const Settings = React.lazy(() => import(/* webpackChunkName: "Settings" */ '../Settings/Settings'));
const AboutUs = React.lazy(() => import(/* webpackChunkName: "AboutUs" */ '../FootersPages/AboutUs'));
const ContactUs = React.lazy(() => import(/* webpackChunkName: "ContactUs" */ '../FootersPages/ContactUs'));
const TutoChooseModel = React.lazy(() => import(/* webpackChunkName: "TutoChooseModel" */ '../FootersPages/TutoChooseModel'));
const GettingStarted = React.lazy(() => import(/* webpackChunkName: "GettingStarted" */ '../FootersPages/GettingStarted'));
const DocumentationVideo = React.lazy(() => import(/* webpackChunkName: "DocumentationVideo" */ '../FootersPages/DocumentationVideo'));
const DocumentationTexteCarousel = React.lazy(() => import(/* webpackChunkName: "DocumentationTexte" */ '../FootersPages/DocumentationTexte'));
const GuideCreerCompte = React.lazy(() => import(/* webpackChunkName: "GuideCreerCompte" */ '../FootersPages/Guide/GuideCreerCompte'));
const ChoisirModele = React.lazy(() => import(/* webpackChunkName: "ChoisirModele" */ '../FootersPages/Guide/ChoisirModele'));
const ChoisirHistoire = React.lazy(() => import(/* webpackChunkName: "ChoisirHistoire" */ '../FootersPages/Guide/SelectionHistoire'));
const CreerHistoire = React.lazy(() => import(/* webpackChunkName: "CreerHistoire" */ '../FootersPages/Guide/CreerHistoire'));
const DevenirExpert = React.lazy(() => import(/* webpackChunkName: "DevenirExpert" */ '../FootersPages/Guide/DevenirExpert'));
const CGU = React.lazy(() => import(/* webpackChunkName: "CGU" */ '../FootersPages/CGU'));
const IdentificationMention = React.lazy(() => import(/* webpackChunkName: "IdentificationMention" */ '../FootersPages/IdentificationMention'));
const PrivacyPolicy = React.lazy(() => import(/* webpackChunkName: "PrivacyPolicy" */ '../FootersPages/PrivacyPolicy'));
const BuyPage = React.lazy(() => import(/* webpackChunkName: "BuyPage" */ '../Payments/BuyPageNew'));
const TestMinio = React.lazy(() => import(/* webpackChunkName: "TestMinio" */ '../tests/minio'));

export {
  HomePage,
  CreatorLandingPage,
  AdminPage,
  Story,
  GameInterface,
  CreateListStories,
  SelectStories,
  Create,
  CreateOptions,
  StoryGenerator,
  Login,
  SignUp,
  ForgotPassword,
  Settings,
  AboutUs,
  ContactUs,
  TutoChooseModel,
  GettingStarted,
  DocumentationVideo,
  DocumentationTexteCarousel,
  GuideCreerCompte,
  ChoisirModele,
  ChoisirHistoire,
  CreerHistoire,
  DevenirExpert,
  CGU,
  IdentificationMention,
  PrivacyPolicy,
  BuyPage,
  TestMinio,
};
export { LazyPage };
